import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-faq-title',
    templateUrl: './faq-title.component.html',
    styleUrls: ['./faq-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FaqTitleComponent implements OnInit, OnDestroy {
  cmsContent: any;
  private subscriptions = new Subscription();

  constructor(
    private readonly cmsData: CmsService,
    public readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.cmsData.getComponentData('faqTextParagraph').subscribe((res) => {
        const faqTextParagraph: any = JSON.parse(JSON.stringify(res));
        this.cmsContent = faqTextParagraph.content;
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
